import { Directive, HostListener } from '@angular/core';

@Directive({
    selector: '[st-click-stop-propagation]',
})
export class ClickStopPropagationDirective {
    @HostListener('click', ['$event'])
    public onClick(event: any): void {
        event.stopPropagation();
    }
}
@Directive({
    selector: '[st-space-stop-propagation]',
})
export class SpaceStopPropagationDirective {
    @HostListener('keydown.space', ['$event'])
    public onSpace(event: any): void {
        event.stopPropagation();
    }
}

@Directive({
    selector: '[st-enter-stop-propagation]',
})
export class EnterStopPropagationDirective {
    @HostListener('keydown.enter', ['$event'])
    public onEnter(event: any): void {
        event.stopPropagation();
    }
}
